'use strict'

import HttpClient from './HttpClient'

class File extends HttpClient {
  urls = {}
  constructor (type = '', refId = '') {
    super()
    if (refId) {
      refId = '/' + refId
    }
    const apiUrl = {
      carrierQuoteRequest: {
        all: '/api/carrier/get/all/quote/request/job/docs' + refId,
        upload: '/api/carrier/upload/quote/request/job/one/doc' + refId,
        getOne: '/api/carrier/download/one/quote/request/job/docs',
        delete: '/api/carrier/delete/one/quote/request/job/docs'
      },
      shipperQuoteRequest: {
        all: '/api/shipper/get/all/quote/request/job/docs' + refId,
        upload: '/api/shipper/upload/quote/request/job/one/doc' + refId,
        getOne: '/api/shipper/download/one/quote/request/job/docs',
        delete: '/api/shipper/delete/one/quote/request/job/docs'
      }
    }
    switch (type) {
      case 'carrier-quote':
        this.urls = apiUrl.carrierQuoteRequest
        break
      case 'shipper-quote':
        this.urls = apiUrl.shipperQuoteRequest
        break
      default:
        alert('ระบุเอกสารผิดพลาด')
    }
  }
  getUploadUrl () {
    return process.env.VUE_APP_LOGISTY_API_HOST_NAME + this.urls.upload
  }
  deleteDoc (docId) {
    var url = this.urls.delete

    var data = {
      docId: docId
    }

    return this.sendDelete(url, this.headers, data)
  }
  getAllDoc () {
    var url = this.urls.all
    return this.sendGet(url, this.headers)
  }
  downloadFile (fileId) {
    var url = this.urls.getOne + '/' + fileId
    return this.sendGetFile(url, this.headers)
  }
}

export default File
